/* eslint-disable */
$(".js-switch-address").on("click", e => {
  console.log('js switch address is pressed');
  e.preventDefault();
  $(".shipping-address").slideToggle();
});
$(".js-submit-change-shipping").on("click", e => {
  e.preventDefault();
  const userData = {
    street_name: $(".js-shipping-street").val(),
    housenumber: $(".js-housenumber").val(),
    place_name: $(".js-place").val(),
    postal_code: $(".js-postal-code").val()
  };
  jQuery.ajax({
    type: "POST",
    url: arturo_vars.ajax_url,
    dataType: "json",
    data: {
      action: "change_user_address",
      data: userData
    },
    success: function (data) {
      if (data.success) {
        $(".shipping-address").append(`
					<p style="margin-top: 5px;">${arturo_vars.address_changed}</p>
				`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
    error: function (err) {
      console.log(err);
    }
  });
});